export default __webpack_public_path__ + "static/diners-cafba9a9a174eb21e395b94fca424666.jpg";